import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Typography,
} from '@mui/material'
import { Control, Controller, useFormContext } from 'react-hook-form'

type CheckboxItem = {
  label: string
  value: string
}

type FormCheckboxProps = {
  name: string
  label: string
  control: Control<any>
  items: CheckboxItem[]
  multiple?: boolean
}

const FormCheckbox = (props: FormCheckboxProps) => {
  const { name, label, control, items, multiple } = props

  const { setValue } = useFormContext()

  return (
    <FormControl component="fieldset" variant="standard">
      <FormLabel>
        <Typography
          color="black"
          variant="body1"
          component="span"
          fontWeight={700}
          marginBottom="10px"
          fontSize={{
            md: '14px !important',
            xs: '12px !important',
          }}
        >
          {label}
        </Typography>
      </FormLabel>
      <FormGroup>
        {items.map((item, index) => (
          <Controller
            key={index}
            name={`${name}`}
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      multiple
                        ? field.value?.includes(item.value)
                        : field.value === item.value
                    }
                    size="small"
                    sx={{ pt: 0, pb: 0 }}
                    value={item.value}
                    disableRipple
                  />
                }
                aria-label={item.label}
                label={item.label}
                {...field}
                onChange={() => {
                  if (multiple) {
                    if (field.value?.includes(item.value)) {
                      setValue(
                        field.name,
                        field.value.filter(
                          (value: string) => value !== item.value
                        ) || []
                      )
                    } else {
                      setValue(field.name, [...(field.value || []), item.value])
                    }
                  } else {
                    if (field.value === item.value) {
                      setValue(field.name, '')
                    } else {
                      setValue(field.name, item.value)
                    }
                  }
                }}
              />
            )}
          />
        ))}
      </FormGroup>
    </FormControl>
  )
}

export default FormCheckbox
